export default {
  labels: {
    order: 'Tilaus',
    customer: 'Asiakas',
  },
  tags: {
    new_customer: 'Uusi asiakas',
    loyal_customer: 'Kanta-asiakas',
  },
};
